import { ApiOldBaseHelper } from "./ApiOldBaseHelper";
import { GetWarehousesForAdminUserResponse, WarehouseDTO } from "./ApiServerVov";

export class APIVovWarehouseHelper extends ApiOldBaseHelper {
    public async GetWarehousesForAdminUser(): Promise<WarehouseDTO[] | undefined> {
        return (await this.GetAdressedAuthRefreshableClient().getWarehousesForAdminUser()).warehouses;
    }
    
}